import React from 'react';
import { useLocation } from 'react-router-dom';
import { useStringFromId } from '@nykaa/intl-shared';
import styled from 'App/styled';
import { useDispatch, useSelector } from 'react-redux';
import PageTypes from 'constants/pageTypes';
import SearchIcon from 'components/Icons/Search';
import SearchBarPlaceholder from './SearchBarPlaceholder';
import MicroPhone from 'components/VoiceSearch/Microphone';
import { toggleVoiceModal } from 'store/searchSuggestions/action';
import { getPlaceholderText, getSearchURL } from './helper';
import { State } from 'store/types';

const Wrapper = styled.div`
  padding: 0 8px;
  position: relative;
`;

const SearchLink = styled.a`
  height: 40px;
  width: 100%;
  padding: 0 12px 0 8px;
  border: 1px solid #e5e5e5;
  display: flex;
  align-items: center;
  border-radius: 2px;
  text-decoration: none;
  ${({ theme }) => theme.typography.subTitleMedium};
  margin-right: 12px;
  color: ${({ theme }) => theme.colors.surfaceInverse10};
  background: #f7f7f7;
  .microphone svg {
    opacity: 1;
  }
  svg {
    margin-right: 4px;
    opacity: 48%;
  }
`;
interface Props {
  currentPage: string;
  searchTerm?: string;
  hasVoiceSearch: boolean;
  searchTextHp: [{ text: string; textColor: string }];
}

const SearchButton = ({
  currentPage,
  searchTerm,
  hasVoiceSearch,
  searchTextHp,
}: Props) => {
  const dispatch = useDispatch();
  const isNewSearchEnabled = useSelector(
    (state: State) => state.remoteConfig.switches.isNewSearchBarEnabled
  );

  let placeHolderText = useStringFromId(getPlaceholderText());

  if (currentPage === PageTypes.SEARCH_LISTING && searchTerm) {
    placeHolderText = searchTerm;
  }
  const { pathname } = useLocation();
  const searchURL = getSearchURL(pathname);

  const handleMicrophone = () => {
    dispatch(toggleVoiceModal(true));
  };

  if (isNewSearchEnabled) {
    return (
      <SearchBarPlaceholder
        searchURL={searchURL}
        placeHolder={placeHolderText}
        hasVoiceSearch={hasVoiceSearch}
        handleMicrophone={handleMicrophone}
        searchTextHp={searchTextHp}
        currentPage={currentPage}
      />
    );
  }

  return (
    <Wrapper>
      <SearchLink href={searchURL}>
        <SearchIcon />
        {placeHolderText}
        {hasVoiceSearch && (
          <MicroPhone
            customClass="microphone"
            handleMicrophone={handleMicrophone}
          />
        )}
      </SearchLink>
    </Wrapper>
  );
};

export default SearchButton;
